import { offsetDateForBrowser } from '../../../shared/timeZoneLogic';

export const AVAILABILITY_DISCLAIMER = 'Dates not listed are not available.';

export const holdDatesHeader = (venueName) => {
  const name = String(venueName || '').replace(/[\s:]+$/, '').trim();
  if (!name) {
    return null;
  }
  return /\s/.test(name) ? `${name}:` : `${name} holds:`;
};

export default function buildHoldDatesText(holdPositions, venueName, tz, appendAvailabilityDisclaimer = false) {
  const positions = (holdPositions || []).filter((hp) => hp && hp.start_time);
  if (positions.length === 0) {
    return '';
  }

  const lines = positions
    .slice()
    .sort((a, b) => new Date(a.start_time) - new Date(b.start_time))
    .map((hp) => {
      const date = offsetDateForBrowser(new Date(hp.start_time), tz).toDateString();
      return `${date} H${hp.position}`;
    });

  const header = holdDatesHeader(venueName);
  const prefix = header ? [header] : [];
  const suffix = appendAvailabilityDisclaimer ? [AVAILABILITY_DISCLAIMER] : [];
  return [...prefix, ...lines, ...suffix].join('\n');
}
